export default "__VITE_ASSET__e385d38a__"